export default {
  mcInboundList: {
    search: {
      inboundNo: '委托加工入库单号',
      inboundNoPlaceholder: '请输入委托加工入库单号',
      contractNo: '委托加工采购合同号',
      contractNoPlaceholder: '请输入委托加工采购合同号',
      externalContractNo: '委托加工外部合同号',
      externalContractNoPlaceholder: '请输入委托加工外部合同号',
      distributionInboundNo: '物流入库单号',
      distributionInboundNoPlaceholder: '请输入物流入库单号',
      instructionNo: '供应商发货指令号',
      instructionNoPlaceholder: '请输入供应商发货指令号',
      inboundBatchNo: '入库批次号',
      inboundBatchNoPlaceholder: '请输入入库批次号',
      inboundStatus: '入库单状态',
      inboundStatusPlaceholder: '请选择订单状态',
      productDesc: '商品描述',
      productDescPlaceholder: '请选择成品名称',
      productNo: '商品编码',
      productNoPlaceholder: '请选择成品编码搜索',
      startInboundCreateDate: '制单日期开始',
      inboundCreateDatePlaceholder: '请选择日期',
      endInboundCreateDate: '制单日期结束',
      inboundCreatePersonNo: '制单人',
      inboundCreatePersonNoPlaceholder: '请选择制单人',
      accountingStatus: '入账状态',
      partnerNo: '供应商',
      businessPersonNo: '业务员',
      inboundCompanyCode: '公司',
      inboundCompanyCodePlaceholder: '请选择公司',
      inboundDepartmentCode: '部门',
      inboundDepartmentCodePlaceholder: '请选择部门',
      inboundStorageNo: '商品入库仓库',
      inboundStorageNoPlaceholder: '请选择仓库',
    },
    table: {
      id: '序号',
      inboundNo: '委托加工入库单号',
      contractNo: '委托加工采购合同号',
      externalContractNo: '委托加工外部合同号',
      distributionInboundNo: '物流入库单号',
      instructionNo: '供应商发货指令号',
      instructionDetailNo: '供应商发货指令行号',
      inboundBatchNo: '入库批次号',
      inboundStatus: '入库单状态',
      productDesc: '商品描述',
      productNo: '商品编码',
      startInboundCreateDate: '制单日期开始',
      endInboundCreateDate: '制单日期结束',
      inboundCreatePersonNo: '制单人',
      accountingStatus: '入账状态',
      partnerNo: '供应商',
      businessPersonNo: '业务员',
      inboundCompanyCode: '公司',
      inboundDepartmentCode: '部门',
      inboundStorageNo: '商品入库仓库',
      mcAmountWithTax: '含税加工费',
      materialAmount: '原材料总金额',
      productUnit: '计量单位',
      inboundQuantity: '商品数量',
      contractQuantity: '合同数量',
    },
    goodList: {},
    creatDialog: {
      title: '引用供应商发货指令创建委托加工入库单',
      inboundNoPlaceholder: '请输入委托加工入库单号',
    },
    msg: {
      createSalesGoods: '请选择创建入库单的商品',
      createSingleGoods: '一个入库单只允许入库一个供应商发货指令的某一种商品',
    },
  },
};
